/**
 * CanvasPointsRow — `canvas.points` renderer. Draws a scatter of
 * individual `(x, y)` points over the parent canvas's axes; one
 * visual dot per source cell.
 *
 * Attributes (all optional):
 *   - `key`    — series key (defaults to `"default"`)
 *   - `radius` — dot radius in px (defaults to `2`)
 *   - `color`  — hex / rgba string (defaults to the theme accent)
 */
import type { Option } from "../../core/option.ts";
import { Json } from "../../core/json.ts";
import { RendererRow } from "./renderer-row.ts";

/** The `canvas.points` painter row: draws a dot per point of its parent series source. */
export class CanvasPointsRow extends RendererRow {
  get seriesKey(): string {
    return Json.string(this.attrs(), "key") ?? "default";
  }

  get radius(): number {
    return Json.number(this.attrs(), "radius") ?? 2;
  }

  get color(): Option<string> {
    return Json.string(this.attrs(), "color");
  }
}
